var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ecpec",attrs:{"id":_vm.randomId}},[_c('froala',{attrs:{"tag":'textarea',"config":_vm.froalaConfig},model:{value:(_vm.element.content),callback:function ($$v) {_vm.$set(_vm.element, "content", $$v)},expression:"element.content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }